import styled from "styled-components"

export const ScoresList = styled.ol`
    padding-left: 0;
    list-style: none;
`

export const ScoreLi = styled.li`
    font-size: 1.6rem;
    margin-bottom: 0.5rem;
`